import { render, staticRenderFns } from "./placeholderImg.vue?vue&type=template&id=05248338&scoped=true&"
import script from "./placeholderImg.vue?vue&type=script&lang=js&"
export * from "./placeholderImg.vue?vue&type=script&lang=js&"
import style0 from "./placeholderImg.vue?vue&type=style&index=0&id=05248338&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05248338",
  null
  
)

export default component.exports